import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth, getUserDisplayName } from '../firebase';
import { ensureUserProfile, recordUserLogin } from '../api/userProfile';

import '../css/Login.css';


const signUp = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    console.log("User signed up:", userCredential.user);
    return { user: userCredential.user };
  } catch (error) {
    console.error("Error signing up:", error.message);
    return { error: error.message };
  }
};

const login = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    console.log("User logged in:", userCredential.user);
    return { user: userCredential.user };
  } catch (error) {
    console.error("Login error:", error.message);
    return { error: error.message };
  }
};

const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true };
  } catch (error) {
    console.error("Password reset error:", error.message);
    return { error: error.message };
  }
};

// function Login() {
const Login = ({ onLogin }) => {

  // const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // TODO: Add your authentication logic here
  //   console.log('Login attempted with:', email, "; and password:", password);
  //     console.log('Signing in');
  //     login(email, password);
  //     console.log('Login successful');
  //   // signUp(email, password).then(n => {
  //   //   console.log('Signup successful');
  //   // }).then(n => {
  //   //   console.log('Signing in');
  //   //   login(email, password);
  //   //   console.log('Login successful');
  //   // });
  // };

  // const handleSignUp = (e) => {
  //   e.preventDefault();
  //   console.log('Signing up');
  //   console.log('Signing up with:', email, "; and password:", password);
  //   signUp(email, password);
  //   console.log('Signup successful');
  // };
  const [profile, setProfile] = useState({
    providerId: '',
    uid: '',
    displayName: '',
    email: '',
    photoUrl: ''
  });

  const [isLoginMode, setIsLoginMode] = useState(true);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [validationErrors, setValidationErrors] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [signupSuccess, setSignupSuccess] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [isResetMode, setIsResetMode] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);

  // Add validation functions
  const validateUsername = (username) => {
    if (username.length < 3) {
      return 'Username must be at least 3 characters long';
    }
    if (username.length > 20) {
      return 'Username must be less than 20 characters';
    }
    if (!/^[a-zA-Z0-9_]+$/.test(username)) {
      return 'Username can only contain letters, numbers and underscores';
    }
    return '';
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

  const validatePassword = (password) => {
    if (password.length < 8) {
      return 'Password must be at least 8 characters long';
    }
    if (!/[A-Z]/.test(password)) {
      return 'Password must contain at least one uppercase letter';
    }
    if (!/[a-z]/.test(password)) {
      return 'Password must contain at least one lowercase letter';
    }
    if (!/[0-9]/.test(password)) {
      return 'Password must contain at least one number';
    }
    return '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Validate on change
    let error = '';
    switch (name) {
      case 'username':
        error = validateUsername(value);
        break;
      case 'email':
        error = validateEmail(value);
        break;
      case 'password':
        error = validatePassword(value);
        break;
      case 'confirmPassword':
        error = value !== formData.password ? "Passwords don't match" : '';
        break;
      default:
        break;
    }

    setValidationErrors(prev => ({
      ...prev,
      [name]: error
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    // Validate fields based on mode
    let hasErrors = false;
    if (isLoginMode) {
        // For login, only validate email and password
        const emailError = validateEmail(formData.email);
        const passwordError = validatePassword(formData.password);
        hasErrors = emailError || passwordError;

        setValidationErrors({
            username: '',
            email: emailError,
            password: passwordError,
            confirmPassword: ''
        });
    } else {
        // For signup, validate all fields
        const usernameError = validateUsername(formData.username);
        const emailError = validateEmail(formData.email);
        const passwordError = validatePassword(formData.password);
        const confirmPasswordError = formData.password !== formData.confirmPassword 
            ? "Passwords don't match" 
            : '';

        hasErrors = usernameError || emailError || passwordError || confirmPasswordError;

        setValidationErrors({
            username: usernameError,
            email: emailError,
            password: passwordError,
            confirmPassword: confirmPasswordError
        });
    }

    if (hasErrors) {
        setIsLoading(false);
        return;
    }

    try {
        if (isLoginMode) {
            const result = await login(formData.email, formData.password);
            if (result && result.error) {
                setError(result.error);
            } else {
                console.log('Login successful');
                setLoginSuccess(true);
                let user = result.user || auth.currentUser;

                setProfile({
                  providerId: user.providerId,
                  uid: user.uid,
                  displayName: getUserDisplayName(user),
                  email: user.email,
                  photoUrl: user.photoURL
                });

                try {
                  await recordUserLogin(user);
                } catch (persistError) {
                  console.error('Failed to persist login/profile:', persistError);
                }

                // Clear the form
                setFormData({
                    username: '',
                    email: '',
                    password: '',
                    confirmPassword: ''
                });
            }
        } else {
            const result = await signUp(formData.email, formData.password);
            if (result && result.error) {
                setError(result.error);
            } else {
                console.log('Signup successful');
                try {
                  await ensureUserProfile(result.user, { username: formData.username });
                } catch (persistError) {
                  console.error('Failed to create user profile:', persistError);
                }
                setSignupSuccess(true);
                setIsLoginMode(true); // Switch to login mode
                setFormData({
                    username: '',
                    email: '',
                    password: '',
                    confirmPassword: ''
                });
            }
        }
    } catch (err) {
        setError(err.message || 'An error occurred');
    } finally {
        setIsLoading(false);
    }
  };

  // Add this function to reset the login state
  const resetLoginState = () => {
    setLoginSuccess(false);
    setSignupSuccess(false);
    setError(null);
    setFormData({
      username: '',
      email: '',
      password: '',
      confirmPassword: ''
    });
    setIsLoginMode(true);
  };

  // Modify toggleMode to use resetLoginState
  const toggleMode = (e) => {
    e.preventDefault();
    resetLoginState();
    setIsLoginMode(!isLoginMode);
  };

  // Add click handler for the Login link
  // const handleLoginClick = (e) => {
  //   if (loginSuccess) {
  //     e.preventDefault();
  //     resetLoginState();
  //   }
  // };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    // Validate email
    const emailError = validateEmail(formData.email);
    if (emailError) {
      setValidationErrors({
        ...validationErrors,
        email: emailError
      });
      setIsLoading(false);
      return;
    }

    try {
      const result = await resetPassword(formData.email);
      console.log(result);
      if (result.error) {
        setError(result.error);
      } else {
        setResetSuccess(true);
        // Clear email field
        setFormData(prev => ({
          ...prev,
          email: ''
        }));
      }
    } catch (err) {
      setError(err.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
        {loginSuccess ? (
            <div className="success-container" >
                <div className="success-message">
                    Welcome! You have successfully logged in.
                </div>
                <div style={{flex: 2}}>
                  Welcome {profile.displayName},
                  <p>Email: {profile.email}</p>
                  <p>ProviderId: {profile.providerId}</p>
                  <p>UID: {profile.uid}</p>
                </div>
            </div>
        ) : (
            <div className="login-container">
                <form onSubmit={handleSubmit} className="login-form">
                    {!isResetMode ? (
                        // Login/Signup Form
                        <>
                            <h1>{isLoginMode ? 'Login' : 'Sign Up'}</h1>
                            
                            {error && <div className="error-message">{error}</div>}
                            {signupSuccess && (
                                <div className="success-message">
                                    Successfully signed up! Please log in with your credentials.
                                </div>
                            )}
                            
                            {!isLoginMode && (
                            <div className="form-group">
                              <label htmlFor="username">Username:</label>
                              <input
                                id="username"
                                type="text"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                                required
                                autoComplete="username"
                                className={validationErrors.username ? 'input-error' : ''}
                              />
                              {validationErrors.username && (
                                <div className="validation-error">{validationErrors.username}</div>
                              )}
                            </div>
                            )}


                            {(
                              <div className="form-group">
                                <label htmlFor="email">Email:</label>
                                <input
                                  id="email"
                                  type="email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleChange}
                                  required
                                  autoComplete="email"
                                  className={validationErrors.email ? 'input-error' : ''}
                                />
                                {validationErrors.email && (
                                  <div className="validation-error">{validationErrors.email}</div>
                                )}
                              </div>
                            )}

                            <div className="form-group">
                              <label htmlFor="password">Password:</label>
                              <input
                                id="password"
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                autoComplete={isLoginMode ? "current-password" : "new-password"}
                                className={validationErrors.password ? 'input-error' : ''}
                              />
                              {validationErrors.password && (
                                <div className="validation-error">{validationErrors.password}</div>
                              )}
                            </div>

                            {!isLoginMode && (
                              <div className="form-group">
                                <label htmlFor="confirmPassword">Confirm Password:</label>
                                <input
                                  id="confirmPassword"
                                  type="password"
                                  name="confirmPassword"
                                  value={formData.confirmPassword}
                                  onChange={handleChange}
                                  required
                                  autoComplete="new-password"
                                  className={validationErrors.confirmPassword ? 'input-error' : ''}
                                />
                                {validationErrors.confirmPassword && (
                                  <div className="validation-error">{validationErrors.confirmPassword}</div>
                                )}
                              </div>
                            )}

                            <button 
                                type="submit" 
                                disabled={isLoading}
                                className="submit-button"
                            >
                                {isLoading ? 'Processing...' : (isLoginMode ? 'Login' : 'Sign Up')}
                            </button>

                            <div className="toggle-mode">
                                <p>
                                    {isLoginMode ? "Don't have an account? " : "Already have an account? "}
                                    <button 
                                        type="button"
                                        onClick={toggleMode} 
                                        className="link-button"
                                    >
                                        {isLoginMode ? 'Sign Up' : 'Login'}
                                    </button>
                                </p>
                            </div>

                            {isLoginMode && (
                                <div className="forgot-password">
                                    <button
                                        type="button"
                                        className="link-button"
                                        onClick={() => {
                                            setIsResetMode(true);
                                            setError(null);
                                        }}
                                    >
                                        Forgot Password?
                                    </button>
                                </div>
                            )}
                        </>
                    ) : (
                        // Reset Password Form
                        <div className="reset-password-container">
                            <h2>Reset Password</h2>
                            {resetSuccess ? (
                                <div className="success-message">
                                    Password reset email sent! Please check your inbox.
                                    <div className="back-to-login">
                                        <button
                                            type="button"
                                            className="link-button"
                                            onClick={() => {
                                                setIsResetMode(false);
                                                setResetSuccess(false);
                                            }}
                                        >
                                            Back to Login
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <p>Enter your email address to receive a password reset link.</p>
                                    <div className="form-group">
                                        <label htmlFor="reset-email">Email:</label>
                                        <input
                                            id="reset-email"
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            className={validationErrors.email ? 'input-error' : ''}
                                        />
                                        {validationErrors.email && (
                                            <div className="validation-error">{validationErrors.email}</div>
                                        )}
                                    </div>
                                    <button
                                        type="button"
                                        onClick={handleResetPassword}
                                        disabled={isLoading}
                                        className="submit-button"
                                    >
                                        {isLoading ? 'Sending...' : 'Send Reset Link'}
                                    </button>
                                    <div className="back-to-login">
                                        <button
                                            type="button"
                                            className="link-button"
                                            onClick={() => setIsResetMode(false)}
                                        >
                                            Back to Login
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </form>
            </div>
        )}
    </>
  );
}

export default Login;